import styled from "@emotion/styled";

export const Container = styled.div`
  position: relative;
  display: flex;
  width: 454px;
  padding: 40px 48px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;

  box-sizing: border-box;
  border-radius: 20px;
  background: var(--alias-color-background-normal-normal, #fff);

  /* alias/style/shadow/heavy */
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.08);
`;

export const Upper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 24px;
  align-self: stretch;
`;

export const Btns = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
`;

export const AlertIconBackground = styled.div`
  display: flex;
  width: 46px;
  height: 46px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 50%;

  box-shadow: 0px 0px 40px 0px rgba(255, 201, 51, 0.42);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
`;

export const ItemContainer = styled.div`
  display: flex;
  height: 240px;
  max-height: 600px;
  padding: 16px 20px;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  align-self: stretch;

  border-radius: 12px;
  border: 1px solid var(--color-line-strong, #d6d9db);
  background: var(--color-background-normal-alternative, #fafafa);

  overflow-y: auto;
`;

export const CancelIcon = styled.div`
  display: flex;
  width: 20px;
  height: 20px;
  justify-content: center;
  align-items: center;

  position: absolute;
  right: 20px;
  top: 20px;
  cursor: pointer;
`;
